var render, staticRenderFns
import script from "./PsoriasisHypothesisV2.vue?vue&type=script&lang=js&"
export * from "./PsoriasisHypothesisV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe4af72",
  null
  
)

export default component.exports